var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnboardingAvator(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.5 24C47.5 36.9787 36.9787 47.5 24 47.5C11.0213 47.5 0.5 36.9787 0.5 24C0.5 11.0213 11.0213 0.5 24 0.5C36.9787 0.5 47.5 11.0213 47.5 24Z",
    fill: "url(#paint0_linear_4_27)",
    fillOpacity: 0.09,
    stroke: "url(#paint1_linear_4_27)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 36.007C21.2056 36.007 18.6703 34.8079 16.7997 32.8698C16.7983 34.0313 16.7561 35.7077 16.4481 36.9309C16.6501 37.0544 16.8069 37.2571 16.8375 37.5093C17.2367 40.7577 20.3156 43.207 24 43.207C27.6836 43.207 30.7625 40.7574 31.1625 37.5093C31.1935 37.2568 31.3469 37.0544 31.552 36.9313C31.244 35.708 31.2017 34.0314 31.2003 32.8698C29.3297 34.8079 26.7944 36.007 24 36.007Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.044 33.0174C29.1891 34.8651 26.7198 36.007 24 36.007C21.2056 36.007 18.6703 34.8079 16.7997 32.8698C16.7983 34.0313 16.7561 35.7077 16.4481 36.9309C16.6501 37.0544 16.8069 37.2571 16.8375 37.5093C17.014 38.9452 17.7153 40.2237 18.7598 41.2047C23.5766 40.5265 29.0437 35.7702 31.044 33.0174Z",
    fill: "#DAFAAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3857 43.4164C18.2623 43.4164 17.2629 42.6971 16.9001 41.6262L16.8755 41.5455C16.7899 41.2619 16.7541 41.0234 16.7541 40.7848V36L15.0516 41.683C14.8327 42.5188 15.3316 43.3854 16.1688 43.6163L27.0203 46.5225C27.1558 46.5575 27.2912 46.5744 27.4246 46.5744C28.1235 46.5744 28.7621 46.1105 28.9411 45.4269L29.5733 43.4164H19.3857Z",
    fill: "#E3F1FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2 16.007H17.6C15.3945 16.007 13.6 17.8015 13.6 20.007V24.807C13.6 30.9828 18.2656 36.007 24 36.007C29.7344 36.007 34.4 30.9828 34.4 24.807V19.207C34.4 17.4426 32.9648 16.007 31.2 16.007Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6 7.20697H19.2C17.6953 7.20697 16.4305 8.25077 16.0898 9.65187C13.3359 10.002 11.2 12.3598 11.2 15.207V19.207C11.2 21.2687 12.0752 23.1921 13.6 24.559V20.007C13.6 17.8015 15.3945 16.007 17.6 16.007H31.2C32.9648 16.007 34.4 17.4425 34.4 19.207V24.5581C35.9251 23.1914 36.8 21.2682 36.8 19.207V14.407C36.8 10.4371 33.5703 7.20697 29.6 7.20697Z",
    fill: "#060C07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.1632 40.0544C10.5562 44.9319 16.9191 48 24 48C31.0809 48 37.4438 44.9319 41.8368 40.0544C41.0708 39.0188 39.9906 38.1774 38.6016 37.7885C38.5696 37.7795 38.5375 37.7725 38.5047 37.7678L32.1188 36.8096C32.0797 36.8037 31.9961 36.8006 31.9563 36.8006C31.5524 36.8006 31.2118 37.1018 31.1625 37.5029C30.7625 40.7509 27.6836 43.2006 24 43.2006C20.3156 43.2006 17.2367 40.7514 16.8375 37.5029C16.7875 37.09 16.4156 36.7795 16.0234 36.8009C15.9765 36.7982 15.9304 36.8021 15.8812 36.8095L9.4953 37.7677C9.4625 37.7724 9.4305 37.7794 9.3984 37.7884C8.0094 38.1775 6.9292 39.0188 6.1632 40.0544Z",
    fill: "#F7C644"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_27",
    x1: 65.7429,
    y1: 52.7213,
    x2: 3.36152,
    y2: -5.27517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.212258,
    stopColor: "#59C27B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.50961,
    stopColor: "#59C27B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727185,
    stopColor: "#59C27B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59C27B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4_27",
    x1: 65.7429,
    y1: 52.7213,
    x2: 3.36152,
    y2: -5.27517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.212258,
    stopColor: "#59C27B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.50961,
    stopColor: "#F7C644"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727185,
    stopColor: "#EC5676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#144FF5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_27"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingAvator);
export default __webpack_public_path__ + "static/media/onboarding-avator.92eaee6afb1e93963849199a90c376ae.svg";
export { ForwardRef as ReactComponent };